import type { ReactNode } from 'react'

import {
  Binary,
  Calendar,
  DatabaseZap,
  FileIcon,
  FileQuestionIcon,
  ImageIcon,
  LibrarySquareIcon,
  ToggleLeft,
  Type,
} from 'lucide-react'
import { BracketsIcon, TagsIcon } from 'lucide-react'

import { cn } from '../../../../lib/utils'

const TYPE_ICON_MAP = {
  NumberLiteral: Binary,
  StringLiteral: Type,
  DateLiteral: Calendar,
  BooleanLiteral: ToggleLeft,
  Array: BracketsIcon,
  Any: FileQuestionIcon,
  Union: TagsIcon,
  Variable: DatabaseZap,
  FileLiteral: FileIcon,
  Object: LibrarySquareIcon,
  ImageLiteral: ImageIcon,
} as const

type LiteralType = keyof typeof TYPE_ICON_MAP

const TypeIcon = ({ type }: { type: LiteralType }) => {
  const Icon = TYPE_ICON_MAP[type]
  return <Icon className="size-3 shrink-0 text-primary" />
}

interface ToolOutputProps {
  children: ReactNode
  type?: LiteralType
  variant?: 'node' | 'new'
}

/**
 * __Variable__
 *
 * Used to display a variable.
 */
export const Variable = ({
  children,
  variant = 'node',
  type = 'Any',
}: ToolOutputProps) => {
  return (
    <div
      className={cn(
        'gap-x-xs p-s inline-flex items-center rounded border border-border bg-surface',
        variant === 'new' && 'border-primary',
      )}
    >
      <TypeIcon type={type} />
      <code className="font-mono text-xs font-medium leading-none text-primary">
        {children}
      </code>
    </div>
  )
}
